const getHubUsersRequestState = state => state.automationTab.hubUsers.requestState;
export default getHubUsersRequestState;